// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item[data-v-0222625d] {\n  padding: 20px;\n  font-size: 14px;\n  border-bottom: 1px solid #ddd;\n}\n.item .color-blue[data-v-0222625d] {\n  color: #409EFF;\n}\n.pl-20[data-v-0222625d] {\n  padding-left: 20px;\n}\n.pt-20[data-v-0222625d] {\n  padding-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
